// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".normal[data-v-50d9fc0c]{background:#fff;border-color:#9c9c9c}.active[data-v-50d9fc0c]{background:#f1f1ff}.v-menu__content[data-v-50d9fc0c]{border-radius:20px}", ""]);
// Exports
module.exports = exports;
